export const DEFAULT_NEWS_FORMATS = [
    {
        ID: 'hero',
        Name: 'hero',
        AspectRatioWidth: 3,
        AspectRatioHeight: 2,
    },
    {
        ID: 'small',
        Name: 'small',
        AspectRatioWidth: 3,
        AspectRatioHeight: 4,
    },
];

const normalizeName = (value) => {
    return String(value || '')
        .trim()
        .replace(/\s+/g, ' ');
};

const normalizeDimension = (value, fallbackValue) => {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) && numericValue > 0 ? numericValue : fallbackValue;
};

export const makeNewsFormatId = () => {
    return `format-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

/** Derives a format ID from its display name: lowercase, spaces to hyphens. */
export const nameToFormatId = (name) => {
    return String(name || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-');
};

export const normalizeNewsFormat = (format = {}, fallbackFormat = DEFAULT_NEWS_FORMATS[0]) => {
    const formatName = normalizeName(format.Name) || fallbackFormat.Name;

    return {
        ...format,
        ID: format.ID || fallbackFormat.ID || makeNewsFormatId(),
        Name: formatName,
        AspectRatioWidth: normalizeDimension(format.AspectRatioWidth, fallbackFormat.AspectRatioWidth),
        AspectRatioHeight: normalizeDimension(format.AspectRatioHeight, fallbackFormat.AspectRatioHeight),
    };
};

export const normalizeNewsFormats = (formats) => {
    // Un array vuoto e' una sezione senza cover. Un valore assente resta sui formati di default.
    if (Array.isArray(formats) && formats.length === 0) {
        return [];
    }

    const sourceFormats = Array.isArray(formats) ? formats : DEFAULT_NEWS_FORMATS;
    const usedFormatIds = new Set();

    return sourceFormats.map((format, index) => {
        const fallbackFormat = DEFAULT_NEWS_FORMATS[index] || DEFAULT_NEWS_FORMATS[0];
        const normalizedFormat = normalizeNewsFormat(format, fallbackFormat);
        const baseFormatId = normalizedFormat.ID;
        let formatId = baseFormatId;
        let duplicateIndex = 2;

        while (usedFormatIds.has(formatId)) {
            formatId = `${baseFormatId}-${duplicateIndex}`;
            duplicateIndex += 1;
        }

        usedFormatIds.add(formatId);
        return {
            ...normalizedFormat,
            ID: formatId,
        };
    });
};

export const getNewsFormats = (section) => {
    return normalizeNewsFormats(section ? section.NewsFormats : DEFAULT_NEWS_FORMATS);
};

export const getNewsFormatById = (section, formatId) => {
    const formats = getNewsFormats(section);
    if (formats.length === 0) return undefined;
    return formats.find((format) => format.ID === formatId) || formats[0];
};

export const getNewsFormatIdForSection = (formatId, section) => {
    const format = getNewsFormatById(section, formatId);
    return format ? format.ID : null;
};

/** True when the section defines at least one cover format. A missing section keeps the defaults. */
export const sectionHasCoverFormats = (section) => {
    return getNewsFormats(section).length > 0;
};

export const getNewsFormatAspectRatio = (format) => {
    const normalizedFormat = normalizeNewsFormat(format);
    return `${normalizedFormat.AspectRatioWidth} / ${normalizedFormat.AspectRatioHeight}`;
};

export const getNewsFormatRatioValue = (format) => {
    const normalizedFormat = normalizeNewsFormat(format);
    return normalizedFormat.AspectRatioWidth / normalizedFormat.AspectRatioHeight;
};

export const getNewsFormatLabel = (format) => {
    const normalizedFormat = normalizeNewsFormat(format);
    return `${normalizedFormat.Name} ${normalizedFormat.AspectRatioWidth}/${normalizedFormat.AspectRatioHeight}`;
};

export const getNewsFormatOptions = (section) => {
    return getNewsFormats(section).map((format) => ({
        label: getNewsFormatLabel(format),
        value: format.ID,
    }));
};
